module.exports = __webpack_public_path__ + "static/media/item-6.a4f2d3ee.png";